import React, { useState } from "react";
import { TextField, Typography, Box, Button } from "@mui/material";
import { TitleText } from "../../components/common/TitleText";
import { addDoc, collection } from "firebase/firestore";
import { firestore } from "../../firebase";
import { useSnackbar } from "notistack";

const Subscribe = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [email, setEmail] = useState("");
  const addSubscriber = async () => {
    try {
      const docRef = await addDoc(collection(firestore, "subscribers"), {
        email: email,
        date: new Date().toLocaleString(),
      });
      setEmail("");
      enqueueSnackbar("Subscribe Successfully...!!!", {
        variant: "success",
        autoHideDuration: 1500,
      });
    } catch (err) {
      // console.log(err);
    }
  };
  return (
    <div>
      <Box
        container
        sx={{
          marginTop: "10px",
          marginBottom: "40px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <TitleText
          sx={{ textAlign: "center" }}
          fontWeight="bold"
          variant="h4"
          component="h4"
        >
          get on our whitelist
        </TitleText>
        <Typography sx={{ textAlign: "center" }} variant="h6" component="h6">
          Be the first ones to know about our latest collaborations, drops and
          innovations.
        </Typography>
        <TextField
          id="outlined-basic"
          placeholder="Your Email"
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{
            width: { md: "30%", sm: "40%", xs: "70%" },
            "&  ::placeholder": {
              textAlign: "center",
              fontSize: { md: "1.2rem", sm: "1.2rem", xs: "0.8rem" },
            },
            "& input": {
              height: "1rem",
            },
            marginTop: "1rem",
          }}
        />

        <Button
          variant="contained"
          style={{ padding: "5px 10px", marginTop: "1rem" }}
          onClick={addSubscriber}
        >
          Subscribe
        </Button>
      </Box>
    </div>
  );
};

export default Subscribe;
